import React from 'react';

import {
  Apartment,
  CollectionsBookmark,
  ConnectedTv,
  Inbox,
  InfoOutlined,
  LaptopWindows,
  Launch,
  LiveTv,
  Logout,
  MailOutline,
  PinDrop,
  School,
  TextSnippet,
  Work,
} from '@mui/icons-material';
import { SvgIcon } from '@mui/material';

import { ResourceIconName } from 'src/api';
import { HRLogicsIcon } from 'src/assets';

type SvgIconProps = React.ComponentProps<typeof SvgIcon>;

export const ResourceCardIconsMapping: Record<ResourceIconName, React.FC<SvgIconProps>> = {
  Apartment: props => <Apartment {...props} />,
  Collections_Bookmark: props => <CollectionsBookmark {...props} />,
  Connected_Tv: props => <ConnectedTv {...props} />,
  HR_Logics: props => (
    <SvgIcon {...props}>
      <HRLogicsIcon />
    </SvgIcon>
  ),
  Inbox: props => <Inbox {...props} />,
  Info_Outlined: props => <InfoOutlined {...props} />,
  Laptop_Windows: props => <LaptopWindows {...props} />,
  Launch: props => <Launch {...props} />,
  Live_Tv: props => <LiveTv {...props} />,
  Logout: props => <Logout {...props} />,
  Mail_Outline: props => <MailOutline {...props} />,
  Pin_Drop: props => <PinDrop {...props} />,
  School: props => <School {...props} />,
  Text_Snippet: props => <TextSnippet {...props} />,
  Work: props => <Work {...props} />,
};
